const KL_POPOVER_TOGGLE_SELECTOR = '[data-kl-popover-toggle]';
const KL_POPOVER_SELECTOR = '[data-kl-popover]';
const KL_POPOVER_CLOSE_SELECTOR = '[data-kl-popover-close]';

function getEventElement(event) {
  const { target } = event;

  return target instanceof Element ? target : null;
}

function getToggleFor(popover) {
  if (!popover?.id) return null;

  return document.querySelector(`[data-kl-popover-toggle="${popover.id}"]`);
}

function setPopoverState(popover, isOpen) {
  if (!popover) return;

  popover.hidden = !isOpen;

  const toggle = getToggleFor(popover);

  if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

function closePopover(popover, canMoveFocus) {
  if (!popover || popover.hidden) return;

  setPopoverState(popover, false);

  if (!canMoveFocus) return;

  getToggleFor(popover)?.focus();
}

function closeOpenPopovers(popoverToKeep) {
  document.querySelectorAll(KL_POPOVER_SELECTOR).forEach((popover) => {
    if (popover === popoverToKeep) return;

    closePopover(popover, false);
  });
}

function handleToggleClick(toggle) {
  const popover = document.getElementById(toggle.dataset.klPopoverToggle);

  if (!popover) {
    console.debug('kl-popover: no popover found for the trigger', { popoverId: toggle.dataset.klPopoverToggle });
    return;
  }

  closeOpenPopovers(popover);
  setPopoverState(popover, popover.hidden);
}

function handleDocumentClick(event) {
  const element = getEventElement(event);

  if (!element) return;

  const toggle = element.closest(KL_POPOVER_TOGGLE_SELECTOR);

  if (toggle) {
    event.preventDefault();
    handleToggleClick(toggle);
    return;
  }

  const closeButton = element.closest(KL_POPOVER_CLOSE_SELECTOR);

  if (closeButton) {
    closePopover(closeButton.closest(KL_POPOVER_SELECTOR), true);
    return;
  }

  closeOpenPopovers(element.closest(KL_POPOVER_SELECTOR));
}

function handleDocumentKeydown(event) {
  if (event.key !== 'Escape') return;

  const popover = document.querySelector(`${KL_POPOVER_SELECTOR}:not([hidden])`);

  if (!popover) return;

  event.preventDefault();
  closePopover(popover, true);
}

document.addEventListener('click', handleDocumentClick);
document.addEventListener('keydown', handleDocumentKeydown);
